import React from "react";

const Footer = () => {
  return (
    <div className="w-full py-10">
      <p className="text-center text-gray-500 text-base">
        © 2024. All rights reserved by Gerald Nana Kwame Ampadu
      </p>
    </div>
  );
};

export default Footer;
